module.exports = __webpack_public_path__ + "img/v-class.d17afe9d.jpg";